import { render, staticRenderFns } from "./salesRecords.vue?vue&type=template&id=2b75b845&"
import script from "./salesRecords.vue?vue&type=script&lang=js&"
export * from "./salesRecords.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports